import { render, staticRenderFns } from "./errorDialog.vue?vue&type=template&id=78b6716e&scoped=true&"
import script from "./errorDialog.vue?vue&type=script&lang=js&"
export * from "./errorDialog.vue?vue&type=script&lang=js&"
import style0 from "./errorDialog.vue?vue&type=style&index=0&id=78b6716e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b6716e",
  null
  
)

export default component.exports